export type SearchParamValue = string | number | boolean;

export const paramsFromRecord = (
  record: Record<string, SearchParamValue | SearchParamValue[] | undefined>,
): string => {
  const entries = Object.entries(record);
  const definedEntries = entries.filter(
    ([_key, value]) => value !== undefined && value !== '',
  );

  if (definedEntries.length === 0) {
    return '';
  }

  const searchParams = definedEntries.reduce((params, [key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        params.append(key, item.toString());
      });
    } else {
      params.set(key, value!.toString()!);
    }

    return params;
  }, new URLSearchParams());

  return `?${searchParams.toString()}`;
};
